import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Tooltip ,
  IconButton ,
  CircularProgress,
  Modal,
  InputLabel,
  Select,
  Grid,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert, 
  AlertTitle, 
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetEmailDL, getSalesOffices } from "../../utils/GetAdmin";
import { saveEmailDL } from "../../utils/PostAdmin";
import requestMissingContexts, {displayConfig, determineConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import { getAllWarehouseData, saveWarehouseLocation } from "../../utils/GetWarehouse";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"280px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
interface rowData {
  param_value: string;
  email: string;
  guid:string;
  sales_org:string;

}
export default function WarehouseLocation() {
  const classes = useStyles();
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [warehouseLocations, setWarehouseLocations] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", 100);
  const enabled = checkForRole(`${clientId}`,salesOrg,'vp_admin');
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});

  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [selRow, setSelRow] = React.useState<rowData|undefined>(undefined);

  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [latitude, setLatitude] = React.useState<string>("");
  const [longitude, setLongitude] = React.useState<string>("");
  const [modalTitle, setModalTitle] = React.useState<string>("");
  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const [plantDisabled,setPlantDisabled] = React.useState(false);
  const [editedTimeZone, setEditedTimeZone] = React.useState<string>("EST");

  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedRowDeliveringPlant("");
    setLatitude("");
    setLongitude("");
    setEditedTimeZone("");
  }

  
  const handleModalSave = () => {
    saveWarehouseLocation(salesOrg,editedRowDeliveringPlant,latitude,longitude, editedTimeZone).then(res => {
      if(res){
      setOpenEditWindow(false);
      setSelRow(undefined);
      getData();
      }
    });
    
  } 

const handleEdit = (tableMeta:any) => {
  if(tableMeta) setCurrent(tableMeta);
  setModalTitle("Edit Warehouse Location")
  setPlantDisabled(true);
   setOpenEditWindow(true);
 }

 const handleDelete = () => {
  saveWarehouseLocation(salesOrg,editedRowDeliveringPlant,'','','').then(res => {
    if(res){
    setOpenEditWindow(false);
    setSelRow(undefined);
    getData();
    }
  });
}

 const setCurrent = (tableMeta:any) => {
   setEditedRowDeliveringPlant(tableMeta.plant);
   setLatitude(tableMeta.latitude);
   setLongitude(tableMeta.longitude);
   setEditedTimeZone(tableMeta.timezone);
 }

const modalBody = (
  <div style={modalStyle} className={classes.paper} >
  <Typography variant="h4" className={classes.modalTitle} paragraph>{modalTitle}</Typography>
  <Grid container spacing={2}  className={classes.modalGrid}>
    <Grid item xs={14} md={14} xl={12}>
      <Card className={classes.modalCard}>
        <CardContent>
        <Grid container rowSpacing={3} className={classes.modalGrid}>
          <Grid item xs={12} md={12} xl={12}>
            <InputLabel >Delivery Plant</InputLabel>
            <Select label="Delivery Plant" required placeholder='Delivery Plant' value={editedRowDeliveringPlant}
                inputProps={{name: 'Delivery Plant',}} disabled={plantDisabled}
                className={classes.modalInput}
                onChange={(e) => { 
                    setEditedRowDeliveringPlant((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}>
                
                {(deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                  
                    <MenuItem key={so[1].code} value={so[1].code}>
                      {so[1].code + " - " + so[1].text}
                    </MenuItem>
                    ))):(<div></div>)}
            </Select>
          </Grid>
          <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Latitude</InputLabel>
            <TextField placeholder='Latitude' type='number'
                className={classes.modalInput}
                value={latitude}
                onChange={(e) => { 
                  setLatitude((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                }}></TextField>
          </Grid>
          <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Longitude</InputLabel>
            <TextField placeholder='Longitude' type='number'
                className={classes.modalInput}
                value={longitude}
                onChange={(e) => { 
                  setLongitude((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                }}></TextField>
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <InputLabel >Time Zone</InputLabel>
            <Select label="Time Zone" title={`${determineConfig(codes, 'time_zone', editedTimeZone)}`} required placeholder='Time Zone' value={ `${determineConfig(codes, 'time_zone', editedTimeZone)}` }
                inputProps={{name: 'Time Zone',}}
                className={classes.modalInput}
                onChange={(e) => { 
                  const abbrTimeZoneObj = displayConfig(codes, "time_zone").find(ele => ele.text == e.target.value);
                  setEditedTimeZone(abbrTimeZoneObj?.code || 'EST');   
                }}>
                {(displayConfig(codes, "time_zone").map((item: any, index: number) => (
                    <MenuItem key={item.code} value={item.text} title={item.text}>
                      {item.text}
                    </MenuItem>
                    )))}
            </Select>
          </Grid>
        </Grid>
        </CardContent>
        </Card>
        <div style={{ paddingRight: "5px", textAlign:"right"}}>
              <React.Fragment>
                  <Tooltip title={"Save"}>
                      <IconButton onClick={handleModalSave} disabled={(latitude && longitude && editedRowDeliveringPlant && editedTimeZone)?false:true}>
                          <SaveIcon />
                      </IconButton>
                  </Tooltip>
                  <Tooltip title={"Cancel"}>
                      <IconButton onClick={handleModalClose}>
                          <Clear />
                      </IconButton>
                  </Tooltip>
              </React.Fragment>
            </div>
      </Grid>
    </Grid>
  </div>
);

  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES", "PLANTS", "time_zone"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        getData();
      });
  }, [warehouseLocations,doneLoading,salesOrg,muiTable,confirmDelete]);

  const getData =()=>{
    getAllWarehouseData(salesOrg).then((v) => {
      if(v && v.data){ 
      let filteredData = [];
      for(let i=0; i<v.data.length; i++){
        if(v.data[i].latitude!=null && v.data[i].longitude!=null){
         filteredData.push(v.data[i]);
        }
      }
      setWarehouseLocations(filteredData);
      }
    }).then((_) => {
      getSalesOffices(salesOrg)
      .then((v) => {
        setDeliveringPlants(v);
       // setEditedRowDeliveringPlant();
        setDoneLoading(true);
      });
      });
  }

  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <TableAbstraction
        settingsKey="ADM_WAREHOUSE"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Warehouse Location`}>
                  <IconButton  onClick={() => {
                    handleModalClose();
                    setModalTitle("Add Warehouse Location")
                    setOpenEditWindow(true);
                    setPlantDisabled(false);
                  }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Warehouse Locations"
          columns={[
            {
                label: "Delivery Plant",
                name: "plantFullName",
                options: {
                  searchable: true,
                  filter: true,
                },
            },
            {
                label: "Latitude",
                name: "latitude",
                options: {
                  searchable: false,
                  filter: false,
                },
            },
            
            {
                label: "Longitude",
                name: "longitude",
                options: {
                  filter: true,
                  searchable:false
                },
           },
           {
                label: "Time Zone",
                name: "timezone",
                options: {
                  filter: true,
                  searchable: false,
                  renderCell: (props) => {
                    return (<div title={`${determineConfig(codes, 'time_zone', props.row.timezone)}`}>{`${determineConfig(codes, 'time_zone', props.row.timezone)}`}</div>)
                  }
                },
           },
           {
            label: " ",
            name: "remove",
            options: {
              filter: false,
              setCellProps: () => ({ align: 'right' }),
              renderCell: (props) => {
                const tableMeta = props.row;
                  if(!!useCompact)
                  return (
                      <React.Fragment>
                        <Tooltip title={"Edit"}>
                          <EditIcon 
                            fontSize="small"  
                            onClick={() => {handleEdit(tableMeta)}}/>
                        </Tooltip>

                        <Tooltip title={"Delete"}>
                              <IconButton onClick={() => {setCurrent(tableMeta); setConfirmDelete(true);}}>
                                <DeleteIcon />
                              </IconButton>
                        </Tooltip>
                        
                      </React.Fragment>
                    );
                  else
                    return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <IconButton onClick={() => {handleEdit(tableMeta)}}>
                              <EditIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title={"Delete"}>
                              <IconButton onClick={() => {setCurrent(tableMeta); setConfirmDelete(true);}}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          
                        </React.Fragment>
                      );
              }
              
            },
          },
            
          ]}
          data={warehouseLocations}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      
      <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        {modalBody}
      </Modal>

      <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to delete the locations for delivery plant {editedRowDeliveringPlant}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{setSelRow(undefined); setConfirmDelete(false);}} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
        
    </div>
  );
}